import { createContext } from 'react';
import { IAuthContext } from '.';

export const AuthContext = createContext<IAuthContext | undefined>(undefined);
